import { T_ROOT } from '../../constants'
import { TFunction } from 'i18next'

export const getLabelAndplaceholder = (name: string, t: TFunction): { label: string; placeholder: string } => {
  const label = t(`${T_ROOT}.${name}.label`)
  const placeholder = t(`${T_ROOT}.${name}.placeholder`)

  return {
    label,
    placeholder
  }
}
